import { defineMessages } from 'react-intl-next';

export default defineMessages({
	genericErrorHeading: {
		id: 'hub.generic-error-page.heading.non-final',
		defaultMessage: "We're on it",
		description: 'Heading for the generic error page',
	},
	genericErrorDescription: {
		id: 'hub.generic-error-page.description.non-final',
		defaultMessage:
			'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
		description: 'Description for the generic error page',
	},
});
